import {
  PRINCIPAL_AND_INTEREST,
  PROPERTY_TAXES,
  HOMEOWNERS_INSURANCE,
  HOMEOWNERS_ASSOCIATION_FEES,
  PRIVATE_MORTGAGE_INSURANCE,
  MORTGAGE_PAYMENT,
  DOWN_PAYMENT,
  TOTAL_CLOSING_COST,
  MORTGAGE_INSURANCE,
} from './analytics-constants';
import {
  PrincipalAndInterestInput,
  PropertyTaxesInput,
  HomeownersInsuranceInput,
  HomeownersAssociationFeesInput,
  PrivateMortgageInsuranceInput,
  MortgagePaymentInput,
  DownPaymentInput,
  TotalClosingCostInput,
  MortgageInsuranceInput,
} from './inputs';

export const FIELDS_INPUTS_HASH = {
  [PRINCIPAL_AND_INTEREST]: PrincipalAndInterestInput,
  [PROPERTY_TAXES]: PropertyTaxesInput,
  [HOMEOWNERS_INSURANCE]: HomeownersInsuranceInput,
  [HOMEOWNERS_ASSOCIATION_FEES]: HomeownersAssociationFeesInput,
  [PRIVATE_MORTGAGE_INSURANCE]: PrivateMortgageInsuranceInput,
  [MORTGAGE_PAYMENT]: MortgagePaymentInput,
  [DOWN_PAYMENT]: DownPaymentInput,
  [TOTAL_CLOSING_COST]: TotalClosingCostInput,
  [MORTGAGE_INSURANCE]: MortgageInsuranceInput,
};
